import React, { useState } from 'react';
import { useMalcolmContext } from '../../contexts/MalcolmContext';
import IntelligenceFeedHeader from './IntelligenceFeedHeader';
import IntelligenceFeedMain from './IntelligenceFeedMain';
import IntelligenceFeedSidebar from './IntelligenceFeedSidebar';

const AIIntelligenceFeed = () => {
  const { loading, error } = useMalcolmContext();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  // Component is now accessible to all users

  if (loading) {
    return (
      <div className="min-h-screen bg-stone-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-br from-indigo-500 to-teal-600 rounded-lg flex items-center justify-center mx-auto mb-4 animate-pulse">
            <span className="text-2xl">🧠</span>
          </div>
          <h2 className="text-lg font-semibold text-slate-900 mb-2">Loading AI Intel</h2>
          <p className="text-stone-600">Aggregating the latest AI developments...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-stone-50 flex items-center justify-center">
        <div className="text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-4">
            <span className="text-2xl">⚠️</span>
          </div>
          <h1 className="text-xl font-semibold text-slate-900 mb-2">Error Loading Feed</h1>
          <p className="text-stone-600 mb-4">{error}</p>
          <button 
            onClick={() => window.location.reload()}
            className="bg-indigo-600 text-white px-4 py-2 rounded-lg hover:bg-indigo-700 transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-stone-50">
      <IntelligenceFeedHeader 
        onToggleSidebar={() => setSidebarOpen(!sidebarOpen)}
      />
      
      <div className="max-w-7xl mx-auto">
        <div className="flex">
          {/* Main Content */}
          <div className="flex-1 min-w-0">
            <IntelligenceFeedMain />
          </div>
          
          {/* Sidebar */}
          <div className={`
            ${sidebarOpen ? 'block' : 'hidden'} 
            lg:block w-full lg:w-96 xl:w-80 flex-shrink-0 
            lg:ml-6 xl:ml-8
          `}>
            <IntelligenceFeedSidebar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AIIntelligenceFeed;